import React, { useState } from 'react'
import { apiurl } from '../../path'
import { login_side_img } from '../../public/LoginImages/importimages';
const ForgetPassword = () => {
  const [email, setEmail] = useState('');
  
  const handleResetPassword = async (e) => {
    e.preventDefault();
    try {
    let Forgettoken=await fetch(apiurl+'/ForgetPassword',
    {method:"POST",
    headers:({'Content-Type': 'Application/json'}),
    body:JSON.stringify({email:email})})
    Forgettoken= await Forgettoken.json()
   if(Forgettoken)
   {
    alert('link has sent to email')
   }else{
    alert('Not valid Email')
   }

    } catch (error) {
      console.error("Error in AdminLogin:", error);
    }
  };
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', height: '100vh', alignItems: 'center' }}>
      <img src={login_side_img} style={{ width: "60vw" }} />
      <div style={{textAlign:'center',marginRight:'85px'}}>
        <h2 style={{color:'orange'}}>Forgot Password?</h2>
        <p style={{fontSize:"12px"}}>Enter your registered email address, and we will help you to
          set a new password.</p>
        <form onSubmit={handleResetPassword}>
          <input
            style={{border:"none",borderRadius:"0",borderBottom:"2px solid"}}
            type="email"
            placeholder="Enter your email"
            onChange={(e) => setEmail(e.target.value)}
            required
            className='form-control'
          />
          <button type='submit' className="btn btn-primary my-5" style={{width:"40%",border:"1px solid red",borderRadius:"20px",backgroundColor:"#e73d26"}}>Send Reset Link</button>
          <div>
                    <p style={{color:'orange'}}><a href='/AdminLogin'>Back To Sign In</a></p>
                  </div>
        </form>
      </div>
    </div>
  )
}

export default ForgetPassword